<ion-header>
  <ion-toolbar class="header-modal">
    <ion-title>{{ title | translate }}</ion-title>
    @if (showCloseButton) {
    <ion-buttons slot="end">
      <ion-button (click)="onClose()" fill="clear">
        <ion-icon slot="icon-only" name="close" color="light" />
      </ion-button>
    </ion-buttons>
    }
  </ion-toolbar>
</ion-header>
